import {
	Container,
	ContainerPadding,
	CTA,
	Text,
	TokenTextAppearance,
} from '@volkswagen-onehub/components-core';
import React, { useState } from 'react';
import { GenericErrorLayer, Loading } from 'src/components';
import { IdPerson } from 'src/types';

interface BajaComunicacionesScreenProps {
	idPerson: IdPerson;
	sendAltaForm: () => Promise<boolean>;
}

export const BajaComunicacionesScreen = (
	props: BajaComunicacionesScreenProps,
) => {
	const { idPerson, sendAltaForm } = props;
	const [alta, setAlta] = useState(false);
	const [errorAlta, setErrorAlta] = useState(false);
	const [loading, setLoading] = useState(false);

	const handleAlta = async () => {
		setLoading(true);
		const sent = await sendAltaForm();
		setLoading(false);
		if (sent) {
			setAlta(true);
		} else {
			setErrorAlta(true);
		}
	};

	const altaCTA = (
		<CTA
			onClick={e => {
				e.preventDefault();
				handleAlta();
			}}
			tag="button"
			emphasis="tertiary"
			size="small"
		>
			aquí
		</CTA>
	);

	return loading ? (
		<Loading />
	) : errorAlta ? (
		<>
			<GenericErrorLayer
				title="Uy, algo ha pasado"
				bodycopy="Por alguna razón no hemos podido realizar la petición."
				notShowCTA={true}
				icon={false}
				notALayer={true}
			/>
		</>
	) : !alta ? (
		<Container>
			<Container padding={{ bottom: ContainerPadding.static350 }}>
				<Text bold appearance={TokenTextAppearance.headline300}>
					{idPerson.FirstName}, hemos recibido tu solicitud de baja.
				</Text>
			</Container>
			<Container padding={{ bottom: ContainerPadding.static350 }}>
				<Text appearance={TokenTextAppearance.copy200}>
					Actualmente estamos tramitando tu petición para que no
					recibas más comunicaciones comerciales de Volkswagen Group
					España Distribución.
				</Text>
			</Container>
			<Container padding={{ bottom: ContainerPadding.static350 }}>
				<Text appearance={TokenTextAppearance.copy200}>
					Durante este proceso, es posible que aún recibas algún
					contenido. Agradecemos tu paciencia y comprensión.
				</Text>
			</Container>
			<Text appearance={TokenTextAppearance.copy200}>
				Si has hecho click por error y te gustaría seguir recibiendo
				nuestras comunicaciones, por favor, confírmanos {altaCTA}.
			</Text>
		</Container>
	) : (
		<>
			<Container padding={{ bottom: ContainerPadding.static350 }}>
				<Text bold appearance={TokenTextAppearance.headline300}>
					¡Genial, {idPerson.FirstName}! Gracias por confirmarnos.
				</Text>
			</Container>
			<Container padding={{ bottom: ContainerPadding.static350 }}>
				<Text appearance={TokenTextAppearance.copy200}>
					Seguiremos enviándote comunicaciones para que estés siempre
					al día.
				</Text>
			</Container>
			<Text appearance={TokenTextAppearance.copy200}>
				Nos vemos pronto.
			</Text>
		</>
	);
};
